import React from "react"
import NavBarLogo from "components/NavBarLogo"
import { generateMediaUrl } from "shared/imports/sharedHelperFunctions"
import { decodeStyles } from "imports/styleHelperFunctions"
import sheetVars from "app/static/stylus/sheets-variables.json"
const sheetsVariables = decodeStyles(sheetVars)

/*
This navbar is currently used in public sheets to render a Quorum logo and organization logo
*/
const SimpleNavBar = (props) => (
    <div>
        <ul id="gn-menu" className="gn-menu-main">
            <NavBarLogo image_url={generateMediaUrl(props.image_url)} />
            {window.innerWidth > sheetsVariables.MAX_MOBILE_WIDTH && (
                <span className="sheet-name-public">{props.sheetName}</span>
            )}
        </ul>
    </div>
)
export default SimpleNavBar
